const en = {
  header: {
    title: 'Demographic Map',
    subtitle: 'Hispanic Analysis and SRS Branches'
  },
  cache: {
    title: 'System Cache',
    entries: 'Entries:',
    size: 'Size:',
    clearButton: 'Clear Cache',
    clearConfirm: 'Are you sure you want to clear the cache? This will require reloading all data.'
  },
  layers: {
    title: 'Map Layers',
    zipcodes: 'Density Zip',
    densityZip: 'Hispanic Density Zip',
    certainteed: 'SRS Branches',
    visible: '(Visible)',
    hidden: '(Hidden)',
    description: 'Turn layers on or off to customize your map view.',
    noLayersVisible: 'No visible layers'
  },
  filters: {
    title: 'Filters',
    country: 'Country of Origin',
    dma: 'DMA',
    estado: 'State',
    region: 'Region',
    allCountries: 'All countries',
    allDmas: 'All DMAs',
    allEstados: 'All states',
    allRegions: 'All regions',
    sucursal: 'Branch',
    allSucursales: 'All SRS branches',
    applyFilters: 'Apply Filters',
    topHispanicRanking: 'Top 200 Hispanics',
    showTopHispanic: 'Show Top 200 Hispanics',
    clearTopHispanic: 'Clear Ranking'
  },
  countries: {
    mexicano: 'Mexico',
    puerto_rico: 'Puerto Rico',
    cubano: 'Cuba',
    colombia: 'Colombia',
    dom_republic: 'Dominican Republic',
    guatemala: 'Guatemala',
    el_salvador: 'El Salvador',
    honduras: 'Honduras',
    ecuador: 'Ecuador',
    peru: 'Peru',
    venezuela: 'Venezuela',
    espana: 'Spain'
  },
  statistics: {
    title: 'Statistics',
    zipcodes: 'Zip Codes',
    totalPopulation: 'Total Population',
    hispanicPopulation: 'Hispanic Population',
    averagePercentage: 'Hispanic Population %',
    distribution: 'Distribution by Country',
    storeCountByConcentration: 'Store Count by Hispanic Concentration',
    storeCountByDmaSize: 'Store Count by DMA Size Rank',
    hispanicPopulationTradeArea: 'Hispanic Population in Trade Area',
    coverageDmaHispanic: 'Coverage: % DMA Hisp Population in Trade Area'
  },
  map: {
    loadingData: 'Loading map data...',
    zoom: 'Zoom:',
    loading: 'Loading:',
    polygons: 'Polygons',
    branches: 'SRS Branches'
  },
  legend: {
    zipDensity: 'Density Zip',
    hispanicConcentration: 'Hispanic Concentration',
    low: 'Low (0-10%)',
    medium: 'Medium (10-25%)',
    high: 'High (25-50%)',
    veryHigh: 'Very High (50%+)',
    certainteedPoints: 'Certainteed Points',
    certainteedStores: 'Certainteed Stores',
    stores: 'Stores',
    noLayersVisible: 'No visible layers'
  },
  login: {
    title: 'Login',
    subtitle: 'Enter your credentials to access',
    username: 'Username',
    password: 'Password',
    usernamePlaceholder: 'Enter your username',
    passwordPlaceholder: 'Enter your password',
    login: 'Login',
    loggingIn: 'Logging in...',
    defaultCredentials: 'Default credentials: ana / pulido'
  },
  popup: {
    zipCode: 'ZIP Code:',
    totalPopulation: 'Total Population:',
    hispanics: 'Hispanics:',
    breakdown: 'Breakdown by Country:',
    estado: 'State:',
    distributor: 'Distributor:',
    dba: 'DBA:',
    address: 'Address:',
    city: 'City:',
    phone: 'Phone:',
    manager: 'Manager:',
    website: 'View website',
    na: 'N/A',
    dma: 'DMA:',
    ranking: 'Ranking',
    branch: 'Branch:',
    hispanicPopulation: 'Hispanic Population:',
    totalPopulationRanking: 'Total Population:',
    hispanicPercentage: 'Hispanic %:'
  },
  certainteed: {
    title: 'Certainteed Filters',
    filtersAvailable: 'Available Filters',
    filtersDescription: 'Select criteria to filter SRS branches on the map.',
    estado: 'State:',
    dba: 'DBA (Trade Name):',
    city: 'City:',
    zipCode: 'Zip Code:',
    placeholder: 'Ex: 90210',
    apply: 'Apply',
    clear: 'Clear',
    allEstados: 'All states',
    allDbas: 'All DBAs',
    searchDbas: 'Search company...',
    allCities: 'All cities',
    loadingFilters: 'Loading filters...'
  },
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    reset: 'Reset',
    apply: 'Apply',
    clear: 'Clear'
  }
};

/** English only: both keys point to the same strings. */
export const translations = { en, es: en };

export const getNestedText = (translationsObj, path, fallback = '') => {
  return path.split('.').reduce((obj, key) => obj && obj[key], translationsObj) || fallback;
};

export const detectBrowserLanguage = () => 'en';

export const getStoredLanguage = () => {
  const storedLang = localStorage.getItem('app_language');
  if (storedLang === 'es') {
    localStorage.setItem('app_language', 'en');
  }
  return 'en';
};
